// src/utils/coordTransform.js
// 坐标系转换工具类

const PI = Math.PI;
const X_PI = PI * 3000.0 / 180.0;

// 判断是否在中国境内
function outOfChina(lng, lat) {
  return (lng < 72.004 || lng > 137.8347) || (lat < 0.8293 || lat > 55.8271);
}

function transformLat(x, y) {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
  return ret;
}

function transformLng(x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
  return ret;
}

// 新增：格式化经纬度，保留6位小数
function formatLngLat(lng, lat) {
  return [Number(lng.toFixed(6)), Number(lat.toFixed(6))];
}

// WGS84 -> GCJ-02
function wgs84ToGcj02(lng, lat) {
  if (outOfChina(lng, lat)) {
    return formatLngLat(lng, lat);
  }
  let dLat = transformLat(lng - 105.0, lat - 35.0);
  let dLng = transformLng(lng - 105.0, lat - 35.0);
  const radLat = lat / 180.0 * PI;
  let magic = Math.sin(radLat);
  magic = 1 - 0.00669342162296594323 * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((6335552.717000426 * magic) / (sqrtMagic * sqrtMagic) * PI);
  dLng = (dLng * 180.0) / (6378245.0 / sqrtMagic * Math.cos(radLat) * PI);
  const mgLat = lat + dLat;
  const mgLng = lng + dLng;
  return formatLngLat(mgLng, mgLat);
}

// GCJ-02 -> WGS84
function gcj02ToWgs84(lng, lat) {
  if (outOfChina(lng, lat)) {
    return formatLngLat(lng, lat);
  }
  const [mgLng, mgLat] = wgs84ToGcj02(lng, lat);
  return formatLngLat(lng * 2 - mgLng, lat * 2 - mgLat);
}

// GCJ-02 -> BD-09
function gcj02ToBd09(lng, lat) {
  const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * X_PI);
  const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * X_PI);
  const bdLng = z * Math.cos(theta) + 0.0065;
  const bdLat = z * Math.sin(theta) + 0.006;
  return formatLngLat(bdLng, bdLat);
}

// BD-09 -> GCJ-02
function bd09ToGcj02(bdLng, bdLat) {
  const x = bdLng - 0.0065;
  const y = bdLat - 0.006;
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  const ggLng = z * Math.cos(theta);
  const ggLat = z * Math.sin(theta);
  return formatLngLat(ggLng, ggLat);
}

// WGS84 -> BD-09
function wgs84ToBd09(lng, lat) {
  const [gcjLng, gcjLat] = wgs84ToGcj02(lng, lat);
  return gcj02ToBd09(gcjLng, gcjLat);
}

// BD-09 -> WGS84
function bd09ToWgs84(bdLng, bdLat) {
  const [gcjLng, gcjLat] = bd09ToGcj02(bdLng, bdLat);
  return gcj02ToWgs84(gcjLng, gcjLat);
}

export default {
  wgs84ToGcj02,
  gcj02ToWgs84,
  gcj02ToBd09,
  bd09ToGcj02,
  wgs84ToBd09,
  bd09ToWgs84
};